import PurchareRequestsScreen from "../../Screen/ERP/Compras/PurchaseRequestScreen";
import AprobarRequisasScreen from "../../Screen/ERP/Compras/Requisas/AprobarRequisa/AprobarRequisaScreen";
import LiberarRequisaScreen from "../../Screen/ERP/Compras/Requisas/LiberarRequisas/LiberarRequisaScreen";
import LiberarBodegaScreen from "../../Screen/ERP/Compras/Requisas/LiberarRequisas/LiberarBodegaScreeen";
import ProveedoresScreen from "../../Screen/ERP/Compras/Proveedores/ProveedoresScreen";
import CustomerScreen from "../../Screen/ERP/Compras/Customers/CustomerScreen";
import TermScreen from "../../Screen/ERP/Compras/Term/TermScreen";
import CustomerDetailsScreen from "../../Screen/ERP/Compras/Customers/CustomerDetails/CustomerDetailsScreen";
import OrdenesComprasScreen from "../../Screen/ERP/Compras/OrdenesCompras/OrdenesComprasSreen";
import IngresoBodegaScreen from "../../Screen/ERP/Suministros/Bodegas/IngresosBodega/IngresoBodegaScreen";

export const ComprasRouter = [
  {
    path: "Compras/Requisas",
    permiso: 26,
    element: <PurchareRequestsScreen />,
  },
  {
    path: "Compras/LiberarRequisa",
    permiso: 29,
    element: <LiberarRequisaScreen />,
  },
  {
    path: "Compras/LiberarBodega",
    permiso: 30,
    element: <LiberarBodegaScreen />,
  },
  {
    path: "Compras/AprobarRequisa",
    permiso: 31,
    element: <AprobarRequisasScreen />,
  },
  {
    path: "Compras/Proveedores",
    permiso: 32,
    element: <ProveedoresScreen />,
  },
  {
    path: "Compras/Terms",
    permiso: 33,
    element: <TermScreen />,
  },
  {
    path: "Compras/Customers",
    permiso: 34,
    element: <CustomerScreen />,
  },
  {
    path: "Compras/CustomerDetails",
    permiso: 35,
    element: <CustomerDetailsScreen />,
  },
  {
    path: "Compras/OrdenCompras/Listado",
    permiso: 27,
    element: <OrdenesComprasScreen />,
  },
  {
    path: "Compras/IngresoServicios",
    permiso: 92,
    element: <IngresoBodegaScreen Bodega={false} MateriaPrima={false} Servicios={true}/>,
  },
];

export default ComprasRouter;
